import localConfig from './configs/sentry.config.local';
import stagingConfig from './configs/sentry.config.staging';
import productionConfig from './configs/sentry.config.production';

const getCurrentEnvironment = (url) => {
  switch (url) {
    case 'actionableagile-for-azure-staging.55degrees-apps.net': return 'staging';
    case 'actionableagile-for-azure.55degrees-apps.net': return 'production';
    default: return 'local';
  }
}

const currentEnvironment = getCurrentEnvironment(window.location.hostname);

const sentryConfigs = {
  'local': localConfig,
  'staging': stagingConfig,
  'production': productionConfig,
};

export const AppContext = {
  get environment() {
    return currentEnvironment;
  },
  get isProduction() {
    return currentEnvironment === 'production';
  },
  get sentryConfig() {
    return sentryConfigs[currentEnvironment];
  },
};
